const yTitle = 'Halo Score';

export default yTitle;
